<template>
  <div>
    <!-- 查询条件 -->
    <b-row ref="queryFormWrapper" >
      <b-col cols="9">
        <b-form inline>
          <b-form-input
            style="min-width:150px;"
            class="m-1"
            placeholder="联系人"
            v-model="queryParam.criteria.keywords"
          ></b-form-input>

          <b-button variant="outline-primary" @click="handleQuery" class="m-1">查询</b-button>
        </b-form>
      </b-col>
      <b-col cols="3">
        <span class="navbar-text">余额：{{orgFinDto.balanceAmount}}</span>
        <b-button class="ml-3 m-1 float-right" variant="primary" @click="openAddChargeDialog">充值</b-button>
      </b-col>
    </b-row>

    <!-- 列表 -->
    <div style="min-height:430px;" class="mt-2">
      <b-table
        id="data-table"
        responsive
        hover
        :fields="fields"
        :items="items.data"
        :busy="tableLoading"
        :show-empty="true"
        primary-key="ID"
        empty-text="暂无数据"
        :no-local-sorting="true"
      >
        <template v-slot:table-busy>
          <div class="my-2 d-flex justify-content-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </template>

        <template v-slot:cell(paymentType)="data">
          <b-badge variant="success" v-if="data.value=='0'">转账</b-badge>
          <b-badge variant="info" v-if="data.value=='1'">线上支付</b-badge>
        </template>

        <template v-slot:cell(contactName)="data">
          {{data.item.contactName}}({{data.item.contactTel}})
        </template>

        <template v-slot:cell(applyStatus)="data">
          <b-badge variant="secondary" v-if="data.value=='0'">待处理</b-badge>
          <b-badge variant="success" v-if="data.value=='1'">成功</b-badge>
          <b-badge variant="danger" v-if="data.value=='2'">失败</b-badge>
        </template>


        <template v-slot:cell(actions)="row">
          <b-link @click="deleteRecharge(row.item.id)" v-if="row.item.applyStatus=='0'" class="mr-2">删除</b-link>
          <b-link @click="handleView(row.item.id)" class="mr-2">查看</b-link>
        </template>
      </b-table>
    </div>

    <!-- 分页 -->
    <div ref="paginationWrapper" class="mt-3">
      <div class="text-right float-left mx-2" style="height:30px;line-height:30px;"></div>
      <b-pagination
        class="float-right"
        @change="list"
        v-model="queryParam.page"
        :per-page="queryParam.size"
        :total-rows="items.totalElements"
        aria-controls="data-table"
        align="right"
      ></b-pagination>
      <div
        class="text-right float-right mx-2"
        style="height:30px;line-height:30px;"
      >共&nbsp;{{items.totalElements}}&nbsp;条</div>
    </div>

    <loading :show="pageLoading"></loading>
    
    <!-- 转账对话框 -->
    <b-modal
      id="addRechargeModal"
      title="提交充值说明"
      incline
      v-model="addChargeDialogVisible"
      @ok="handleAddCharge"
    >
      <template slot="modal-ok">充值</template>
      <template slot="modal-cancel">取消</template>

      <b-alert show variant="success">
        <p>第一步：通过银行转账至东港瑞宏的帐户：</p>
        <p>第二步：将转账的截图在下面的文本框上传</p>
        <p>第三步：提交成功后，经工作人员核实之后，将转账金额充值到您的帐户</p>
      </b-alert>

      <form enctype="multipart/form-data">
        <validation-observer ref="addRechargeForm">
          <validation-provider
              :rules="{required:true,integer: true}"
              name="金额"
              v-slot="validationContext"
              >
            <b-form-group label="金额" label-cols="3" :invalid-feedback="validationContext.errors[0]">
              <b-form-input 
                v-model="addRechargeDto.amount" 
                :state="validateState(validationContext)"
                placeholder="请输入充值金额">
              </b-form-input>
            </b-form-group>
          </validation-provider>


            <b-form-group label="转账凭证" label-cols="3">
              <b-form-file
                v-model="file1"
                :state="Boolean(file1)"
                accept="image/*"
                placeholder="请选择一个图片文件或者拖到这里..."
                drop-placeholder="将文件拖放到这里..."
              ></b-form-file>
            </b-form-group>

          <validation-provider
              :rules="{max:20}"
              name="联系人"
              v-slot="validationContext"
              >
            <b-form-group label="联系人" label-cols="3" :invalid-feedback="validationContext.errors[0]">
              <b-form-input 
                v-model="addRechargeDto.contactName" 
                :state="validateState(validationContext)"
                placeholder="请输入联系人">
              </b-form-input>
            </b-form-group>
          </validation-provider>

          <validation-provider
              :rules="{max:15}"
              name="联系电话"
              v-slot="validationContext"
              >
            <b-form-group label="联系电话" label-cols="3" :invalid-feedback="validationContext.errors[0]">
              <b-form-input 
                v-model="addRechargeDto.contactTel" 
                :state="validateState(validationContext)"
                placeholder="请输入联系电话">
              </b-form-input>
            </b-form-group>
          </validation-provider>


        </validation-observer>
      </form>
    </b-modal>    
  </div>
</template>

<script>
import * as rechargeFacade from "../../../api/recharge-facade.js";
import * as orgfinFacade from "../../../api/orgfin-facade.js";
import * as orgFacade from "../../../api/org-facade.js";

export default {
  // validations:
  props:{
    orgId: String,
    file1: File
  },
  data() {
    return {
      fields: [
        {
          key: "paymentType",
          label: "付款方式"
        },
        {
          key: "amount",
          label: "付款金额"
        },
        {
          key: "contactName",
          label: "联系方式"
        },
        {
          key: "applyStatus",
          label: "处理状态"
        },
        {
          key: "createTime",
          label: "提交时间"
        },
        {
          key: "actions",
          label: "操作",
          thClass: "actions"
        }
      ],

      // 以下为数据展示和传输对象，基本上与后台接口的传输对象一致
      items: {
        totalElements: 0,
        data: []
      },
      queryParam: {
        size: 10,
        page: 1,
        criteria: {
          orgId: this.orgId,
          keywords: "",
        },
        sortOrder: { createTime: "descending" }
      },
      pageLoading: false,
      tableLoading: false, // 表格Loading状态

      orgFinDto: {},
      orgDto:{},
      addRechargeDto: {},
      addChargeDialogVisible: false,
    }
  },

  created() {
    this.getOrgInfo();

  },
  mounted() {
    // 异步加载列表数据
    this.showMyOrgFin();

    this.handleQuery();

  },
  methods: {
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    // 异步加载列表数据
    list(page) {
      if (page) {
        this.queryParam.page = page;
      }
      this.tableLoading = true; // 打开表格的Loading状态
      rechargeFacade
        .pageList(this.queryParam) // 异步调用后台接口
        .then(res => {
          this.items = res; // 为表格填充数据
          this.tableLoading = false; // 关闭表格的Loading状态
        })
        .catch(err => {
          console.log("err", err);
          this.tableLoading = false;
        });
    },

    handleQuery(){
      this.list()
    },

    // 我的账户余额
    showMyOrgFin(){
      orgfinFacade
        .orgFin(this.orgId) // 异步调用后台接口
        .then(res => {
          this.orgFinDto = res; // 为表格填充数据
          this.tableLoading = false; // 关闭表格的Loading状态
        })
        .catch(err => {
          console.log("err", err);
          this.tableLoading = false;
        });
    },

    // 打开对话框
    openAddChargeDialog(){
      this.addChargeDialogVisible = true;
    },

    handleAddCharge(e){
      e.preventDefault();

      this.$refs.addRechargeForm.validate().then(success => {
        if (!success) {
          return;
        }

        if(!this.file1){
          return;
        }

      console.log(this.file1)
      var data = new FormData();
      data.append("file",this.file1);
      data.append("amount",this.addRechargeDto.amount);
      data.append("contactName",this.addRechargeDto.contactName);
      data.append("contactTel",this.addRechargeDto.contactTel);
      data.append("orgId", this.orgId)

      rechargeFacade
        .addRecharge(data) // 异步调用后台接口
        .then(() => {
          this.$message({
            message: "添加充值记录成功",
            type: "success"
          });
          this.list();
          this.addChargeDialogVisible=false;
          this.tableLoading = false; // 关闭表格的Loading状态
        })
        .catch(err => {
          console.log("err", err);
          this.tableLoading = false;
        });
      })


    },

    // 将机构负责人信息赋值
    getOrgInfo(){
      orgFacade
          .getOrgInfo(this.orgId)
          .then(res => {
            this.pageLoading = false;
            this.addRechargeDto.contactName = res.orgBoss;
            this.addRechargeDto.contactTel = res.orgBossMobile;
          })
          .catch(err => {
            console.log("err", err);
            this.pageLoading = false;
          });      
    },
    // 查看图片
    handleView(id) {
      let fileUrl = process.env.VUE_APP_RECHARGE_DOWNLOAD_PREFIX + id;
      let viewerUrl = "./#/imageViewer?file=";
      window.open(viewerUrl + encodeURIComponent(fileUrl));
    },

    // 删除
    deleteRecharge(val){
      this.$bvModal
        .msgBoxConfirm("确认删除该记录吗？", {
          title: "删除",
          size: "sm",
          buttonSize: "md",
          okVariant: "primary",
          okTitle: "确认",
          cancelTitle: "取消",
          footerClass: "p-2",
          hideHeaderClose: false
        })
        .then(value => {
          if (value) {
            // 执行删除操作
            this.pageLoading = true;
            rechargeFacade
              .deleterow(val)
              .then(() => {
                this.pageLoading = false;
                this.$message({
                  message: "删除成功",
                  type: "success"
                });
                this.list();
              })
              .catch(err => {
                this.pageLoading = false;
                console.log("err", err);
              });

          }
        })
        .catch(err => {
          console.log(err);
        });   
    },
  }
};
</script>

<style >
</style>
